module.exports = __webpack_public_path__ + "static/media/iStock-698621996.33aff38d.jpg";